export const globalMessageChineseSimplify = {
  deactivate: "停用",
  success: "成功",
  search_placeholder: "搜索...",
  select_placeholder: "请选择...",
  array_placeholder: "多个值，用逗号分隔",
  select_variable: "选择变量",
  press_enter_search: "按回车键搜索",
  delete_success: "删除成功",
  delete_failed: "删除失败",
  duplicate_success: "复制成功",
  duplicate_failed: "复制失败",
  create_success: "创建成功",
  create_failed: "创建失败",
  update_success: "更新成功",
  update_failed: "更新失败",
  upload_success: "上传成功",
  upload_failed: "上传失败",
  authenticate_success: "验证成功",
  authenticate_failed: "验证失败",
  revealed_success: "显示成功",
  revealed_failed: "显示失败",
  activate_success: "启用成功",
  activate_failed: "启用失败",
  deactivate_success: "停用成功",
  deactivate_failed: "停用失败",
  import_failed: "导入失败",
  import_success: "导入成功",
  export_failed: "导出失败",
  export_success: "导出成功",
  download_failed: "下载失败",
  download_success: "下载成功",
  invite_success: "邀请成功",
  invite_failed: "邀请失败",
  redeem_success: "兑换成功",

  export_credits_title: "导出 {type} 为 CSV",
  export_credits_desc:
    "您即将导出 {type}。根据您选择的数量，可能需要一些时间。",
  unsave: "取消保存",
  draw_failed: "绘制失败",
  please_fill: "请先填写表单",
  field_not_valid: "字段无效",
  enable: "启用",
  disabled: "已停用",
  under_the_min_length: "少于最小数量",
  over_the_max_length: "超过最大数量",
  under_the_min_value: "小于最小值",
  over_the_max_value: "超过最大值",

  /** sort filter start */
  sort_filter_panel_title: "排序与筛选",
  sort_filter_panel_reset: "重置",
  sort_filter_panel_sort_by_title: "排序依据",
  sort_filter_panel_filter_title: "筛选",
  sort_filter_sort_by_create_descending: "创建日期（新到旧）",
  sort_filter_sort_by_create_ascending: "创建日期（旧到新）",
  sort_filter_sort_by_modify_descending: "最后修改（新到旧）",
  sort_filter_sort_by_modify_ascending: "最后修改（旧到新）",
  /** sort filter end */

  days: "天",
  hours: "小时",
  minutes: "分钟",
  apply: "应用",

  sequence_editor_toolbar_link_form_text: "文本",
  sequence_editor_toolbar_link_form_url: "链接",

  authenticate_failure_title: "连接失败",
  authenticate_failure_desc: "我们无法连接您的凭据。请检查您的信息后再试一次。",
  authenticate_failure_button_text: "关闭",
  authenticate_success_title: "连接成功",
  authenticate_success_desc: "您的账户已连接，您现在可以开始使用。",
  authenticate_success_button_text: "关闭",

  selections_desc_max:
    "您当前的套餐最多可选择 0 项。| 您当前的套餐最多可选择 1 项。| 您当前的套餐最多可选择 {count} 项。",
  selections_upgrade_now: "立即升级",
  selections_upgrade_now_desc: "以解锁更多功能！",

  not_email_format: "不符合邮箱格式",
  run_success: "运行成功",
  run_failed: "运行失败",
  signUpFailed: "注册失败",
  signUpSuccess: "注册成功",

  save_success: "保存成功",
  save_failed: "保存失败",
  send_email_success: "邮件已发送到您的邮箱。",
  send_email_failed: "发送邮件失败",

  empty_list: "这里还没有内容",
  retry: "重试",

  remove_styles: "移除样式",
  is_required: "{0}为必填项",

  current_page: "当前页面",
  customize: "自定义",
  field_required: "此字段为必填项",

  select_year: "选择年份",
  select_month: "选择月份",

  asending: "升序",
  descending: "降序",
  copy: "复制",
  select_datetime: "选择日期时间",

  non_permission_field: "您没有权限编辑此字段",
  access_denied_title40348: "访问请求被拒绝",
  access_denied_desc40348:
    "您的访问请求已被工作区管理员拒绝。您可以联系管理员了解更多详情或稍后再试。",
  access_denied_request40348: "请求访问",
  access_denied_title40349: "订阅权限被拒绝",
  access_denied_desc40349:
    "您当前的订阅计划不包括此功能的访问权限。请升级您的订阅以继续使用。",
  access_denied_request40349: "升级订阅",

  no_admin_found: "抱歉，未找到管理员账户。",

  started_at: "开始于 {0}",
  will_ends: "将于 {0} 结束",
  ended_at: "已于 {0} 结束",

  upcoming: "即将开始",
  ended: "已结束",

  input_number_format: "请输入数值。",
  input_array_format: "请输入数组值。",
  input_string_format: "请输入字符串值。",
  field_type_not_match: '导入的值："{value}" \n此值无法匹配到 {name} 字段。',
  already_exists: "该项已存在，请输入不同的名称。",
  invalid_url: "无效的 URL 格式",
  select_date: "请选择日期",
  second_unit: "0 秒 | 1 秒 | {count} 秒",
  try_success: "测试成功",
  try_failed: "测试失败",

  // sort
  sort_popover_timestamp_ascending: "最早优先",
  sort_popover_timestamp_descending: "最新优先",
  sort_popover_amount_ascending: "最低优先",
  sort_popover_amount_descending: "最高优先",
  sort_popover_cost_duration_ascending: "耗时最短",
  sort_popover_cost_duration_descending: "耗时最长",
  sort_popover_alphabet_ascending: "A → Z",
  sort_popover_alphabet_descending: "Z → A",
  sort_popover_count_ascending: "数量最少",
  sort_popover_count_descending: "数量最多",

  last_modified: "最后修改时间",
  last_trigger_at: "最近触发时间",
  create_at: "创建时间",
  total_credit: "总积分",
  processing_time_ms: "处理时长（毫秒）",
  total_signals: "信号总数",
  retry_attempt: "重试次数",
  retry_success: "重试成功",
  retry_failed: "重试失败",
  no_logs_to_retry: "没有可重试的日志",
  retry_partial_success: "已成功重试 {0}/{1} 条日志。请查看日志了解详情。",
  emailAlreadyExists: "该邮箱地址已被使用。",
  validateEmailFailed: "邮箱地址校验失败。",
  array_input_placeholder: "输入关键词并按 Enter 键添加...",

  more_count: "+ {count} 个",
  company_url_name: "公司",
  linkedin_url_name: "LinkedIn",
  facebook_url_name: "Facebook",
  instagram_url_name: "Instagram",
  twitter_url_name: "Twitter",
  youtube_url_name: "YouTube",
  github_url_name: "GitHub",
  tiktok_url_name: "TikTok",
  x_url_name: "X",
  crunchbase_url_name: "Crunchbase",
  wantedly_url_name: "Wantedly",
  rocketpunch_url_name: "Rocketpunch",
  angelist_url_name: "AngelList",
  pinterest_url_name: "Pinterest",
  remember_url_name: "Remember",
  tw104_url_name: "104.com.tw",
  vimeo_url_name: "Vimeo",
  vk_url_name: "VK",
  youtrust_url_name: "YouTrust",

  or: "或",
  and: "且",
  match_prefix: "匹配：",
};

export default globalMessageChineseSimplify;
